// Add your own custom JS here.
document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('.card__title.caption');
    elements.forEach(element => {
        if (element.scrollHeight > element.clientHeight) {
            element.classList.add('truncated');
        }
    });
});
